import { render, staticRenderFns } from "./Sandbox.vue?vue&type=template&id=0b8fe1e6&scoped=true&"
import script from "./Sandbox.vue?vue&type=script&lang=js&"
export * from "./Sandbox.vue?vue&type=script&lang=js&"
import style0 from "./Sandbox.vue?vue&type=style&index=0&id=0b8fe1e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b8fe1e6",
  null
  
)

export default component.exports